const getChecklistAPI = (roleId, category) => `api/checklist?roleId=${roleId}&category=${category}`;

const getCheckListCategory = (category) => `api/checklist?category=${category}`;

const createChecklistItemAPI = () => 'api/checklist/item';

const createChecklistItemsMultipleAPI = () => '/api/checklist/item/multiple';

const editChecklistItemAPI = (checklistItemId) => `api/checklist/item/${checklistItemId}`;

const deleteChecklistItemAPI = (checklistItemId) => `api/checklist/item/${checklistItemId}`;

const submitUserNTChecklistAPI = () => 'api/checklist/nt';

const fetchUserChecklistAPI = (id) => `/api/checklist/user/${id}`;

const getUserNTChecklistAPI = (userId) => `api/checklist/nt?userId=${userId}`;

const submitUserShiftChecklistAPI = () => 'api/checklist/shift';

const getUserShiftChecklistAPI = (userId, shiftTimeId, category) =>
  `api/checklist/shift?userId=${userId}&shiftTimeId=${shiftTimeId}&category=${category}`;

const getTodoChecklistAPI = () => 'api/checklist/to-do';

const submitTodoChecklistAPI = (checklistId) => `api/checklist/nt/${checklistId}`;

const updateChecklistCommentAPI = (commentId) => `api/checklist/comments/${commentId}`;

const deleteChecklistCommentAPI = (commentId) => `api/checklist/comments/${commentId}`;

export const checklistEndpoints = {
  getChecklistAPI,
  getCheckListCategory,
  createChecklistItemAPI,
  createChecklistItemsMultipleAPI,
  editChecklistItemAPI,
  deleteChecklistItemAPI,
  submitUserNTChecklistAPI,
  fetchUserChecklistAPI,
  getUserNTChecklistAPI,
  submitUserShiftChecklistAPI,
  getUserShiftChecklistAPI,
  getTodoChecklistAPI,
  submitTodoChecklistAPI,
  updateChecklistCommentAPI,
  deleteChecklistCommentAPI,
};
